export default {
  'Business Details': [
    {
      name: 'Title',
      label: 'Shop Name',
      type: 'textShort',
      rules: ['requiredString', 'maxChars40'],
    },
    {
      name: 'Contact Email',
      label: 'Contact Email',
      type: 'email',
      rules: ['emailRule'],
      hint: 'This is the email address associated with your account.',
    },
    {
      name: 'Support Email',
      label: 'Support Email',
      type: 'email',
      rules: ['emailRule'],
      hint:
        'This email will be used for new order notifications and as a contact on the Help page.',
    },
    {
      name: 'Instagram',
      label: 'Instagram Name',
      type: 'textShort',
      hint: 'You don\'t need to include "@" symbol',
    },
    {
      name: 'Facebook',
      label: 'Facebook Page URL',
      type: 'textShort',
      hint:
        'The full URL for your Facebook Page (e.g. https://facebook.com/MyBakeryName)',
    },
    {
      name: 'Twitter',
      label: 'Twitter Name',
      type: 'textShort',
      hint: 'You don\'t need to include "@" symbol',
    },
    {
      name: 'Not Taking Orders',
      label: 'Not Taking Orders',
      type: 'textLong',
      hint:
        'If your store has no upcoming availabilty to accept sales, this message will appear on your Menu page.',
    },
    {
      name: 'Maintenance Mode',
      label: 'Maintenance Mode',
      type: 'checkbox',
      hint:
        'Disable the site for visitors temporarily. Owners may still view all pages once logged in.',
    },
    {
      name: 'Timezone',
      label: 'Timezone',
      type: 'selectObject',
      hint:
        "Select your shop' timezone for accurate time-related features (daily sales, availability cutoff times, lead times, etc.)",
      options: [
        { name: 'Pacific (PDT)', value: 'America/Los_Angeles' },
        { name: 'Mountain (MDT)', value: 'America/Denver' },
        { name: 'Central (CDT)', value: 'America/Chicago' },
        { name: 'Eastern (EDT)', value: 'America/New_York' },
        { name: 'Alaska (ADT)', value: 'America/Anchorage' },
        { name: 'Hawaii (HST)', value: 'Pacific/Honolulu' },
      ],
      rules: ['required'],
    },
  ],
  Billing: [
    {
      name: 'Subscription',
      label: 'Subscription',
      type: 'subscriptionManagement',
      // hint: '',
    },
  ],
  'Customer Signup': [
    {
      name: 'Hide Address Fields',
      label: 'Hide Address Fields',
      type: 'checkbox',
      hint: 'Hide the Address fields on customer signup',
    },
    {
      name: 'Capture Payment Info',
      label: 'Capture Payment Info',
      type: 'checkbox',
      hint: 'Capture Payment Provider and Username on Signup',
    },
    {
      name: 'Require Phone For Signup',
      label: 'Require Phone For Signup',
      type: 'checkbox',
      hint: 'Require a Customer phone number for Signup',
    },
  ],
  'Home Page': [
    {
      name: 'Home Banner',
      label: 'Home Banner',
      type: 'image',
      hint:
        'This image will appear on your homepage behind the title of your store.',
    },
    {
      name: 'Hide Home Banner Title',
      label: 'Hide Home Banner Title',
      type: 'checkbox',
      hint:
        "Prevent the Shop's title from being displayed on top of the Home Banner image.",
    },
    {
      name: 'Home Page',
      label: 'Home Text',
      type: 'textRich',
      hint: 'Introduce your Shop on the landing page of your Minimart',
    },
  ],
  'About & Help Pages': [
    {
      name: 'Enable About Page',
      label: 'Enable About Page',
      type: 'checkbox',
      hint:
        'Add an About page to your site. Use the "About Page" field to add content',
    },
    {
      name: 'About Page',
      label: 'About Page',
      type: 'textRich',
      hint:
        'Add content to the About Page of your site (The page of your site found at "/about")',
    },
    {
      name: 'Help Page',
      label: 'Help Page',
      type: 'textRich',
      hint:
        'Add content to the Help Page of your site (The page of your site found at "/help")',
    },
  ],
  'Menu Settings': [
    {
      name: 'Menu Gallery',
      label: 'Menu Gallery',
      type: 'gallery',
      rules: ['maxImages4'],
      hint: 'Choose up to four photos to appear at the top of your menu.',
    },
    {
      name: 'Low Stock Warning',
      label: 'Low Stock Warning',
      type: 'number',
      hint: `When should users see a note about low stock on your menu?\n(Leave Blank or 0 for zero)`,
    },
    {
      name: 'Reject Oversold Orders',
      label: 'Reject Oversold Orders',
      type: 'checkbox',
      hint:
        'If an order contains oversold items, reject it and refresh the inventory for a retry.',
    },
    {
      name: 'Require Prepay',
      label: 'Require Prepay',
      type: 'checkbox',
      hint:
        'By default, customers will be notified they must pay to reserve their order. Uncheck this box to hide those notices.',
    },
    {
      name: 'Allow Gift Purchases',
      label: 'Allow Gift Purchases',
      type: 'checkbox',
      hint:
        'Allow your customers to place orders on behalf of another. This will add an extra few fields to the orders page at checkout.',
    },
    {
      name: 'Enable Item Dates',
      label: 'Enable Item Dates',
      type: 'checkbox',
      hint:
        'Allow Items to be associated with a single date. This will also enable filtering the menu by date for customers. ** 🚨 This feature is in beta. Enable at your own risk.',
    },
    {
      name: 'Lead Time Minutes',
      label: 'Lead Time',
      type: 'leadTime',
      hint:
        'The default Cutoff Time is noon on the Item\'s date. To change it to midnight the day before, for example, set the Cutoff Day to "Day before" and Cutoff Time to "11:59 PM".',
    },
    {
      name: 'Item Oversold Note',
      label: 'Item Oversold Note',
      type: 'textShort',
      hint:
        'This note will show up whenever a customer orders more of an item than was available at the time of purchase',
    },
  ],
  Payment: [
    {
      name: 'Sales Tax',
      label: 'Sales Tax',
      type: 'number',
      hint:
        'Specify in percent with just numbers and decimal points (e.g. "9.5" for 9.5%) - Set to 0 for no tax',
    },
    {
      name: 'Tip Default',
      label: 'Tip Default',
      type: 'price',
      hint: 'When a Customer adds a tip, it will default to this price',
    },
    {
      name: 'Delivery Fee',
      label: 'Delivery Fee',
      type: 'price',
      hint: 'The standard Delivery Fee on all Delivery Orders',
    },
    {
      name: 'Payment Info',
      label: 'Payment Instructions',
      type: 'textRich',
    },
    {
      name: 'Enable Advanced Payment',
      label: 'Enable Advanced Payment',
      type: 'checkbox',
      hint:
        '💸🎉🤑Check this box to enable advanced payment options including payment popup and linking directly to payment apps.',
    },
    {
      name: 'Payment Options',
      label: 'Accepted Payment Providers',
      type: 'multiSelect',
      hint: 'Let your customers know which payment options are available.',
      options: [
        'Venmo',
        'PayPal',
        'CashApp',
        'Credit Card',
        'Apple Pay',
        'Zelle',
        'Square',
        'Cash',
      ],
      hidden: true,
    },
    {
      name: 'Payment Preview',
      label: 'Payment Preview',
      type: 'paymentPreview',
      hint:
        'Preview what the customer sees when they click to pay on their Order Details page. You must save all settings to see them updated in the popup.',
    },
    {
      name: 'Venmo name',
      label: 'Venmo Name',
      type: 'textShort',
      hint: 'To accept Venmo, include just your username (no "@" symbol)',
    },
    {
      name: 'Paypal Email',
      label: 'PayPal Email',
      type: 'textShort',
      rules: ['emailRule'],
      hint: 'To accept PayPal, include your PayPal email address.',
    },
    {
      name: 'Cashapp',
      label: 'CashApp Cashtag ($yourName)',
      type: 'textShort',
      hint: 'To accept CashApp, complete this.',
    },
    {
      name: 'Zelle Contact',
      label: 'Zelle Email or Phone Number',
      type: 'textShort',
      hint:
        'To accept Zelle, enter the email address or phone number associated with you account.',
    },
    {
      name: 'Applepay Phone',
      label: 'Apple Pay Phone Number',
      type: 'textShort',
      rules: ['phoneRule'],
      hint: 'To accept ApplePay via Apple Messages, add your phone number.',
    },
    {
      name: 'cc_instrux',
      label: 'Credit Card Payment Instructions',
      type: 'textRich',
      hint:
        'To accept Credit Card, please enter payment instructions for your customers',
    },
    {
      name: 'cc_phone',
      label: 'Credit Card Phone',
      type: 'textShort',
      rules: ['phoneRule'],
      hint:
        'Provide a phone number for customers to call if they wish to pay by Credit Card.',
    },
    {
      name: 'cash_instrux',
      label: 'Cash Instructions',
      type: 'textLong',
      hint:
        'To accept Cash, please enter payment instructions for your customers',
    },
    {
      name: 'Enable Square Payment',
      label: 'Enable Square Payment',
      type: 'checkbox',
    },
    {
      name: 'Square Location Id',
      label: 'Square Location ID',
      type: 'textShort',
    },
    {
      name: 'Square Access Token',
      label: 'Square Access Token',
      type: 'textHidden',
    },
    {
      name: 'Square App Id',
      label: 'Square App ID',
      type: 'textHidden',
    },
  ],
  Fulfillment: [
    {
      name: 'Fulfillment Options',
      label: 'Fulfillment Options',
      type: 'multiSelect',
      hint: 'What kind of fulfillment do you offer to customers?',
      options: ['Pickup', 'Delivery'],
    },
    {
      name: 'Pickup Info',
      label: 'Pickup Details',
      type: 'textRich',
      hint:
        'Displayed in the Cart when a customer selects "Pickup" as their fulfillment option',
    },
    {
      name: 'Delivery Info',
      label: 'Delivery Details',
      type: 'textRich',
      hint:
        'Displayed in the Cart when a customer selects "Delivery" as their fulfillment option',
    },
    {
      name: 'Fulfillment Instructions',
      label: 'Fulfillment Instructions',
      type: 'textRich',
      hint:
        'Describe the fulfillment process for your customers to pickup their products or accept a delivery (this will show up for both pickup and delivery orders).',
    },
  ],
  Notifications: [
    {
      name: 'Email Customer Invoices',
      label: 'Email Customer Invoices',
      type: 'checkbox',
      hint:
        'Check this if you want your customers to receive Invoices when they place orders.',
    },

    {
      name: 'New Order Alerts',
      label: 'New Order Alerts',
      type: 'checkbox',
      hint:
        'Check this if you wish to receive an email for each order that comes in.',
    },
    {
      name: 'Welcome Email Body',
      label: 'Welcome Email Message',
      type: 'textRich',
      hint: `This is the body content of the Welcome Email that guests receive when they create an account.`,
    },
    {
      name: 'Guest Invoice Title',
      label: 'Guest Invoice Title',
      type: 'textShort',
      hint:
        'Add text here to change what customers see under "Thank you!" on their invoice email',
    },
    {
      name: 'Send Payment Received Email',
      label: 'Send "Payment Received" Email',
      type: 'checkbox',
      hint:
        'Check this to send a Payment Received email to your Customer when an Order is marked "Paid".',
    },
    {
      name: 'BCC Payment Received Email',
      label: 'BCC Shop on Payment Received Emails',
      type: 'checkbox',
      hint:
        'Check this to bcc the Shop Owner on Payment Received Emails. This Shop\'s "contact email" will be used as the recipient.',
    },
    {
      name: 'Email Paid Customization',
      label: '"Payment Received" Email Message',
      type: 'textRich',
      hint: `This message will be *inserted* into the Payment Received email that is sent when an Order is marked Paid.`,
    },
    {
      name: 'Send Order Completed Email',
      label: 'Send "Order Completed" Email',
      type: 'checkbox',
      hint:
        'Check this to send a Order Completed email to your Customer when an Order is marked "Completed".',
    },
    {
      name: 'Email Completed Customization',
      label: '"Order Completed" Email Message',
      type: 'textRich',
      hint: `This message will be *inserted* into the Order Completed email that is sent when an Order is marked Complete.`,
    },
  ],
  'Cancel Subscription': [
    {
      name: 'cancel_subscription',
      label: 'Cancel your Minimart subscription',
      type: 'cancelSubscription',
    },
  ],
}
